<template>
  <section class="loginBgBox">
    <section class="login-visual">
      <div class="network-grid"></div>
      <svg class="route-lines" xmlns="http://www.w3.org/2000/svg">
        <path d="M-120 180 Q 360 20, 780 390 T 1380 210" />
        <path d="M-160 620 Q 430 320, 940 710 T 1520 460" />
        <path d="M220 -120 Q 500 410, 120 920" />
      </svg>
      <div class="brand-head">
        <img class="brand-icon" src="~images/logo.png" alt="全达顺" />
        <div>
          <h1>全达顺</h1>
          <p>现代供应链的全球车队编排与实时物流智能。</p>
        </div>
      </div>
      <div class="visual-main">
        <img src="~images/loginLeftImg.png" alt="物流网络" />
      </div>
    </section>

    <section class="login-form-side">
      <div class="loginBox">
        <div class="form-title">
          <h2>全达顺</h2>
          <p>安全登录以访问终端</p>
        </div>
        <div class="loginCont">
          <el-form :model="saveForm" :rules="rules" ref="saveForm">
            <p class="label">手机号 / 账号 ID</p>
            <el-form-item prop="username">
              <el-input v-model="saveForm.username" placeholder="输入账号或手机号">
                <span slot="prefix" class="field-icon">♙</span>
              </el-input>
            </el-form-item>
            <p class="label">密码</p>
            <el-form-item prop="password">
              <el-input
                :type="passwordVisible ? 'text' : 'password'"
                v-model="saveForm.password"
                placeholder="••••••••"
                @keyup.enter.native="sub('saveForm')"
              >
                <span slot="prefix" class="field-icon">⌕</span>
                <span slot="suffix" class="field-action" @click="passwordVisible = !passwordVisible">
                  {{ passwordVisible ? '隐藏' : '显示' }}
                </span>
              </el-input>
            </el-form-item>
            <p class="label">验证码</p>
            <el-form-item prop="vaildCode">
              <el-input
                v-model="saveForm.vaildCode"
                placeholder="输入图形验证码"
                @keyup.enter.native="sub('saveForm')"
              >
                <span slot="prefix" class="field-icon">✓</span>
                <img
                  class="codeImg cur"
                  slot="suffix"
                  :src="
                    domain +
                    '/genCode?timestamp=' +
                    saveForm.validateCodeKey +
                    '&validateCodeKey=' +
                    saveForm.validateCodeKey
                  "
                  v-loading="imgLoading"
                  @click="refreshImgCode"
                  alt="验证码"
                />
              </el-input>
            </el-form-item>
            <div class="login-options clearPa">
              <span class="remember">记住设备</span>
              <router-link to="forgetPsw" class="forget-link">忘记密码？</router-link>
            </div>
            <el-form-item>
              <div class="btnBox">
                <el-button
                  :loading="loading"
                  class="loginBtn"
                  type="primary"
                  @click.native="sub"
                ><span>立即登录</span><b>→</b></el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="support-box">
          <p>平台新用户？ <router-link to="/register">联系运营人员 / 我要注册</router-link></p>
          <div class="support-links">
            <span>技术支持</span>
            <span>隐私政策</span>
          </div>
        </div>
      </div>
    </section>

    <p class="beian textCenter posiab">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2026087556号-2</a>
    </p>
  </section>
</template>

<script>
import {
  login,
  getUserInfo,
} from 'api/user';
import {
  domain,
} from '@/config';
import { setToken } from '@qx/utils/auth';
import DEFAULT_HOME_PATH from '@/router/defaultHome';
export default {
  name: 'login',
  data () {
    return {
      domain,
      imgLoading: false,
      loading: false,
      passwordVisible: false,
      saveForm: {
        username: '',
        password: '',
        validateCodeKey: new Date().getTime(),
        vaildCode: '',
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],
        vaildCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {

    // 刷新图形验证码
    async refreshImgCode () {
      this.saveForm.validateCodeKey = new Date().getTime();
    },

    formatFormData (formData) {
      let banben = null;
      const agent = navigator.userAgent.toLowerCase();
      const regStrIe = /msie [\d.]+;/gi ;
      const regStrFf = /firefox\/[\d.]+/gi;
      const regStrChrome = /chrome\/[\d.]+/gi ;
      const regStrSaf = /safari\/[\d.]+/gi ;
      // IE
      if (agent.indexOf('msie') > 0) {
        banben = agent.match(regStrIe)[0];
      }
      // firefox
      if (agent.indexOf('firefox') > 0) {
        banben = agent.match(regStrFf)[0];
      }
      // Chrome
      if (agent.indexOf('chrome') > 0) {
        banben = agent.match(regStrChrome)[0];
      }
      // Safari
      if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
        banben = agent.match(regStrSaf)[0];
      }
      const verinfo = banben.replace(/[^0-9.]/ig, '');
      return {
        ...formData,
        banben,
        verinfo,
      };
    },
    sub () {
      this.$refs.saveForm.validate(async (valid) => {
        if (valid) {
          this.saveForm.username = this.saveForm.username.trim();
          if (this.saveForm.username.length !== 11) {
            this.$message.error('请输入正确的手机号');
            return;
          }
          this.loading = true;
          const res = await login(this.formatFormData(this.saveForm));
          this.loading = false;
          if (res.failed) {
            this.refreshImgCode();
          } else if (res === 2) {
            setToken(true);
            this.$router.push('/home');
          } else {
            setToken(true);
            await getUserInfo();
            this.$router.push(DEFAULT_HOME_PATH);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loginBgBox {
  width: 100%;
  min-width: 1180px;
  height: 100vh;
  min-height: 720px;
  display: flex;
  overflow: hidden;
  position: relative;
  background: #f8f9fa;
  color: #191c1d;
  font-family: Inter, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;

  .beian {
    z-index: 10;
    bottom: 12px;
    right: 24px;
    width: auto;
    height: 18px;
    line-height: 18px;
    a {
      color: #8a8f94;
      font-size: 12px;
    }
  }
}

.login-visual {
  width: 58.3333%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px;
  background: #1c1b1b;
  overflow: hidden;

  .network-grid {
    position: absolute;
    inset: 0;
    opacity: 0.35;
    background-image: radial-gradient(circle at 2px 2px, rgba(255, 255, 255, 0.08) 1px, transparent 0);
    background-size: 40px 40px;
  }

  .route-lines {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0.28;
    path {
      fill: none;
      stroke-linecap: round;
      stroke-dasharray: 1000;
      animation: routeFlow 20s linear infinite;
      &:nth-child(1) {
        stroke: #fd761a;
        stroke-width: 2;
      }
      &:nth-child(2) {
        stroke: #06b6d4;
        stroke-width: 1.5;
        animation-delay: -5s;
      }
      &:nth-child(3) {
        stroke: #fff;
        stroke-width: 1;
        animation-delay: -9s;
      }
    }
  }

  .brand-head,
  .visual-main {
    position: relative;
    z-index: 1;
  }

  .brand-head {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    .brand-icon {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      object-fit: cover;
      background: #fff;
      box-shadow: 0 16px 30px rgba(253, 118, 26, 0.28);
    }
    h1 {
      margin: 0;
      color: #fff;
      font-size: 24px;
      line-height: 32px;
      font-weight: 700;
      letter-spacing: -0.02em;
    }
    p {
      max-width: 430px;
      margin-top: 10px;
      color: #858383;
      font-size: 16px;
      line-height: 24px;
    }
  }

  .visual-main {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: min(58vh, 520px);
      height: min(58vh, 520px);
      object-fit: contain;
      filter: drop-shadow(0 30px 45px rgba(0, 0, 0, 0.52));
    }
  }
}

.login-form-side {
  width: 41.6667%;
  min-width: 480px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8f9fa;

  .loginBox {
    width: 100%;
    max-width: 448px;
  }

  .form-title {
    margin-bottom: 38px;
    h2 {
      margin: 0 0 8px;
      color: #000;
      font-size: 40px;
      line-height: 48px;
      font-weight: 800;
      letter-spacing: -0.03em;
    }
    p {
      color: #444748;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .loginCont {
    .label {
      margin-bottom: 7px;
      color: #444748;
      font-size: 11px;
      line-height: 16px;
      font-weight: 700;
      letter-spacing: 0.08em;
    }
    ::v-deep .el-form-item {
      margin-bottom: 21px;
    }
    ::v-deep .el-input__inner {
      height: 48px;
      line-height: 48px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #fff;
      color: #111827;
      font-size: 14px;
      padding-left: 40px;
      padding-right: 42px;
      transition: all 0.18s ease;
      &:focus {
        border-color: #fd761a;
        box-shadow: 0 0 0 3px rgba(253, 118, 26, 0.12);
      }
    }
    ::v-deep .el-input__prefix {
      left: 12px;
      display: flex;
      align-items: center;
    }
    ::v-deep .el-input__suffix {
      right: 10px;
      display: flex;
      align-items: center;
    }
    ::v-deep input::-webkit-input-placeholder {
      color: #9ca3af;
    }
    .field-icon {
      color: #747878;
      font-size: 16px;
      line-height: 1;
      font-weight: 700;
    }
    .field-action {
      color: #747878;
      font-size: 12px;
      cursor: pointer;
      user-select: none;
      &:hover {
        color: #111827;
      }
    }
    .codeImg {
      width: 90px;
      height: 34px;
      object-fit: cover;
      border-radius: 6px;
      border: 1px solid #e5e7eb;
    }
  }

  .login-options {
    margin: -2px 0 20px;
    color: #444748;
    font-size: 14px;
    .remember {
      float: left;
      position: relative;
      padding-left: 22px;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 2px;
        width: 14px;
        height: 14px;
        border-radius: 4px;
        border: 1px solid #c4c7c7;
        background: #fff;
      }
    }
    .forget-link {
      float: right;
      color: #9d4300;
      font-weight: 700;
      &:hover {
        color: #fd761a;
      }
    }
  }

  .btnBox {
    .loginBtn {
      width: 100%;
      height: 56px;
      border: none;
      border-radius: 8px;
      background: #fd761a;
      box-shadow: 0 16px 30px rgba(253, 118, 26, 0.22);
      font-size: 16px;
      font-weight: 700;
      transition: all 0.18s ease;
      &:hover,
      &:focus {
        background: #9d4300;
        box-shadow: 0 18px 34px rgba(157, 67, 0, 0.25);
      }
      span {
        display: inline-block;
        color: #fff;
      }
      b {
        margin-left: 8px;
        color: #fff;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  .support-box {
    margin-top: 40px;
    padding-top: 28px;
    border-top: 1px solid #e5e7eb;
    text-align: center;
    color: #444748;
    font-size: 14px;
    a {
      color: #9d4300;
      font-weight: 700;
      &:hover {
        color: #fd761a;
      }
    }
    .support-links {
      display: flex;
      justify-content: center;
      gap: 30px;
      margin-top: 18px;
      color: #444748;
      font-size: 11px;
      line-height: 16px;
      font-weight: 700;
      letter-spacing: 0.08em;
    }
  }
}

@keyframes routeFlow {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@media screen and (max-width: 1367px) {
  .loginBgBox {
    min-height: 640px;
  }
  .login-visual {
    padding: 34px;
    .visual-main img {
      width: min(52vh, 440px);
      height: min(52vh, 440px);
    }
  }
  .login-form-side {
    .form-title {
      margin-bottom: 28px;
      h2 {
        font-size: 34px;
        line-height: 42px;
      }
    }
    .loginCont ::v-deep .el-form-item {
      margin-bottom: 16px;
    }
    .support-box {
      margin-top: 28px;
      padding-top: 22px;
    }
  }
}
</style>
